// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconStatawrseth } from "../../../icons/mono/build/icon-statawrseth.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const StatawrsethIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconStatawrseth.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  StatawrsethIcon.displayName = 'StatawrsethIcon';
}

export default StatawrsethIcon;